export const PERMS = {
    READ: 'sales.read',
    UPDATE: 'sales.update',
    DELETE: 'sales.delete',
    CREATE: 'sales.create',
}
